const gallery = [
    {
        name: "Japan",
        image: "/images/h1-postmark-5.jpg",
        desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    },
    {
        name: "India",
        image: "/images/h1-postmark-8.jpg",
        desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    },
    {
        name: "USA",
        image: "/images/h1-postmark-4.jpg",
        desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    },
    {
        name: "Italy",
        image: "/images/h1-postmark-3.jpg",
        desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    },
    {
        name: "India",
        image: "/images/h1-postmark-7.jpg",
        desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    },
    {
        name: "France",
        image: "/images/h1-postmark-2.jpg",
        desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    },
    {
        name: "Greece",
        image: "/images/h1-postmark-1.jpg",
        desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    },
    {
        name: "India",
        image: "/images/h1-postmark-6.jpg",
        desc: "Lorem, ipsum dolor sit amet consectetur adipisicing elit.",
    },
]

export default gallery